export const convertSuffix = '&imageMogr2/format/png'; // 添加后缀腾讯云会转格式
